export default {
  'base.setup.title': 'System Setup',
  'base.setup.subtitle': 'Set up the administrator account to start using the system',
  'base.setup.usernameLabel': 'Administrator username',
  'base.setup.usernamePlaceholder': 'Please enter administrator username',
  'base.setup.usernameRequired': 'Please enter administrator username',
  'base.setup.usernameMin': 'Username must be at least 2 characters',
  'base.setup.emailLabel': 'Email',
  'base.setup.emailPlaceholder': 'Enter an email (optional)',
  'base.setup.emailInvalid': 'Invalid email format',
  'base.setup.passwordLabel': 'Login password',
  'base.setup.passwordPlaceholder': 'At least 6 characters',
  'base.setup.passwordRequired': 'Please set a login password',
  'base.setup.passwordMin': 'Password must be at least 6 characters',
  'base.setup.confirmLabel': 'Confirm password',
  'base.setup.confirmPlaceholder': 'Enter password again',
  'base.setup.confirmRequired': 'Please enter the password again',
  'base.setup.confirmMismatch': 'The two passwords do not match',
  'base.setup.submit': 'Complete setup',
  'base.setup.success': 'Setup completed, please sign in',
  'base.setup.failed': 'Setup failed',
}
